/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery } from '@tanstack/react-query';
import type { BodyType, ErrorType } from '../../../../shared/api/custom-instance';

import { customInstance } from '../../../../shared/api/custom-instance';
import type {
  AccumulationTagCreateRequest,
  AccumulationTagUpdateRequest,
  AssessmentsAccumulationMappingsResponse,
  AssessmentsAccumulationPatchRequest,
  AssessmentsComparisonCreateRequest,
  AssessmentsComparisonDeleteResponse,
  AssessmentsComparisonDetailResponse,
  AssessmentsComparisonPatchRequest,
  AssessmentsOptionsResponse,
  ErrorResponse,
  GetAssessmentsComparisonParams,
  GetAssessmentsComparisonsParams,
  GetAssessmentsOptionsParams,
  IdResponse,
  PagedAssessmentsComparisonListResponse,
  SuccessResponse,
} from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 査定比較の一覧を取得します
 * @summary 査定比較一覧取得
 */
export const getAssessmentsComparisons = (
  params?: GetAssessmentsComparisonsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PagedAssessmentsComparisonListResponse>(
    { url: `/assessments/comparisons`, method: 'GET', params, signal },
    options,
  );
};

export const getGetAssessmentsComparisonsQueryKey = (params?: GetAssessmentsComparisonsParams) => {
  return [`/assessments/comparisons`, ...(params ? [params] : [])] as const;
};

export const getGetAssessmentsComparisonsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssessmentsComparisons>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetAssessmentsComparisonsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsComparisons>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAssessmentsComparisonsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssessmentsComparisons>>> = ({
    signal,
  }) => getAssessmentsComparisons(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssessmentsComparisons>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAssessmentsComparisonsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssessmentsComparisons>>
>;
export type GetAssessmentsComparisonsQueryError = ErrorType<ErrorResponse>;

export function useGetAssessmentsComparisons<
  TData = Awaited<ReturnType<typeof getAssessmentsComparisons>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | GetAssessmentsComparisonsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsComparisons>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssessmentsComparisons>>,
          TError,
          Awaited<ReturnType<typeof getAssessmentsComparisons>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAssessmentsComparisons<
  TData = Awaited<ReturnType<typeof getAssessmentsComparisons>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetAssessmentsComparisonsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsComparisons>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssessmentsComparisons>>,
          TError,
          Awaited<ReturnType<typeof getAssessmentsComparisons>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAssessmentsComparisons<
  TData = Awaited<ReturnType<typeof getAssessmentsComparisons>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetAssessmentsComparisonsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsComparisons>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 査定比較一覧取得
 */

export function useGetAssessmentsComparisons<
  TData = Awaited<ReturnType<typeof getAssessmentsComparisons>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetAssessmentsComparisonsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsComparisons>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAssessmentsComparisonsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * EUC取り込みデータの比較を作成します
 * @summary 査定比較作成
 */
export const createAssessmentsComparison = (
  assessmentsComparisonCreateRequest: BodyType<AssessmentsComparisonCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/assessments/comparisons`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: assessmentsComparisonCreateRequest,
      signal,
    },
    options,
  );
};

export const getCreateAssessmentsComparisonMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAssessmentsComparison>>,
    TError,
    { data: BodyType<AssessmentsComparisonCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAssessmentsComparison>>,
  TError,
  { data: BodyType<AssessmentsComparisonCreateRequest> },
  TContext
> => {
  const mutationKey = ['createAssessmentsComparison'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAssessmentsComparison>>,
    { data: BodyType<AssessmentsComparisonCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createAssessmentsComparison(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAssessmentsComparisonMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAssessmentsComparison>>
>;
export type CreateAssessmentsComparisonMutationBody = BodyType<AssessmentsComparisonCreateRequest>;
export type CreateAssessmentsComparisonMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 査定比較作成
 */
export const useCreateAssessmentsComparison = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAssessmentsComparison>>,
      TError,
      { data: BodyType<AssessmentsComparisonCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAssessmentsComparison>>,
  TError,
  { data: BodyType<AssessmentsComparisonCreateRequest> },
  TContext
> => {
  const mutationOptions = getCreateAssessmentsComparisonMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 指定された査定比較の詳細情報を取得します
 * @summary 査定比較詳細取得
 */
export const getAssessmentsComparison = (
  comparisonId: string,
  params?: GetAssessmentsComparisonParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AssessmentsComparisonDetailResponse>(
    { url: `/assessments/comparisons/${comparisonId}`, method: 'GET', params, signal },
    options,
  );
};

export const getGetAssessmentsComparisonQueryKey = (
  comparisonId?: string,
  params?: GetAssessmentsComparisonParams,
) => {
  return [`/assessments/comparisons/${comparisonId}`, ...(params ? [params] : [])] as const;
};

export const getGetAssessmentsComparisonQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssessmentsComparison>>,
  TError = ErrorType<ErrorResponse>,
>(
  comparisonId: string,
  params?: GetAssessmentsComparisonParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsComparison>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssessmentsComparisonQueryKey(comparisonId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssessmentsComparison>>> = ({
    signal,
  }) => getAssessmentsComparison(comparisonId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!comparisonId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssessmentsComparison>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAssessmentsComparisonQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssessmentsComparison>>
>;
export type GetAssessmentsComparisonQueryError = ErrorType<ErrorResponse>;

export function useGetAssessmentsComparison<
  TData = Awaited<ReturnType<typeof getAssessmentsComparison>>,
  TError = ErrorType<ErrorResponse>,
>(
  comparisonId: string,
  params: undefined | GetAssessmentsComparisonParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsComparison>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssessmentsComparison>>,
          TError,
          Awaited<ReturnType<typeof getAssessmentsComparison>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAssessmentsComparison<
  TData = Awaited<ReturnType<typeof getAssessmentsComparison>>,
  TError = ErrorType<ErrorResponse>,
>(
  comparisonId: string,
  params?: GetAssessmentsComparisonParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsComparison>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssessmentsComparison>>,
          TError,
          Awaited<ReturnType<typeof getAssessmentsComparison>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAssessmentsComparison<
  TData = Awaited<ReturnType<typeof getAssessmentsComparison>>,
  TError = ErrorType<ErrorResponse>,
>(
  comparisonId: string,
  params?: GetAssessmentsComparisonParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsComparison>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 査定比較詳細取得
 */

export function useGetAssessmentsComparison<
  TData = Awaited<ReturnType<typeof getAssessmentsComparison>>,
  TError = ErrorType<ErrorResponse>,
>(
  comparisonId: string,
  params?: GetAssessmentsComparisonParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsComparison>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAssessmentsComparisonQueryOptions(comparisonId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 指定された査定比較の名前を更新します
 * @summary 査定比較名更新
 */
export const patchAssessmentsComparison = (
  comparisonId: string,
  assessmentsComparisonPatchRequest: BodyType<AssessmentsComparisonPatchRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/assessments/comparisons/${comparisonId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: assessmentsComparisonPatchRequest,
    },
    options,
  );
};

export const getPatchAssessmentsComparisonMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchAssessmentsComparison>>,
    TError,
    { comparisonId: string; data: BodyType<AssessmentsComparisonPatchRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchAssessmentsComparison>>,
  TError,
  { comparisonId: string; data: BodyType<AssessmentsComparisonPatchRequest> },
  TContext
> => {
  const mutationKey = ['patchAssessmentsComparison'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchAssessmentsComparison>>,
    { comparisonId: string; data: BodyType<AssessmentsComparisonPatchRequest> }
  > = (props) => {
    const { comparisonId, data } = props ?? {};

    return patchAssessmentsComparison(comparisonId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchAssessmentsComparisonMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchAssessmentsComparison>>
>;
export type PatchAssessmentsComparisonMutationBody = BodyType<AssessmentsComparisonPatchRequest>;
export type PatchAssessmentsComparisonMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 査定比較名更新
 */
export const usePatchAssessmentsComparison = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchAssessmentsComparison>>,
      TError,
      { comparisonId: string; data: BodyType<AssessmentsComparisonPatchRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchAssessmentsComparison>>,
  TError,
  { comparisonId: string; data: BodyType<AssessmentsComparisonPatchRequest> },
  TContext
> => {
  const mutationOptions = getPatchAssessmentsComparisonMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 指定された査定比較を削除します
 * @summary 査定比較削除
 */
export const deleteAssessmentsComparison = (
  comparisonId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<AssessmentsComparisonDeleteResponse>(
    { url: `/assessments/comparisons/${comparisonId}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteAssessmentsComparisonMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAssessmentsComparison>>,
    TError,
    { comparisonId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAssessmentsComparison>>,
  TError,
  { comparisonId: string },
  TContext
> => {
  const mutationKey = ['deleteAssessmentsComparison'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAssessmentsComparison>>,
    { comparisonId: string }
  > = (props) => {
    const { comparisonId } = props ?? {};

    return deleteAssessmentsComparison(comparisonId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAssessmentsComparisonMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAssessmentsComparison>>
>;

export type DeleteAssessmentsComparisonMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 査定比較削除
 */
export const useDeleteAssessmentsComparison = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAssessmentsComparison>>,
      TError,
      { comparisonId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAssessmentsComparison>>,
  TError,
  { comparisonId: string },
  TContext
> => {
  const mutationOptions = getDeleteAssessmentsComparisonMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 査定比較の積算項目マッピングを非同期で作成します
 * @summary 積算マッピング作成
 */
export const createAssessmentsAccumulationMapping = (
  comparisonId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponse>(
    { url: `/assessments/comparisons/${comparisonId}/mappings`, method: 'POST', signal },
    options,
  );
};

export const getCreateAssessmentsAccumulationMappingMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAssessmentsAccumulationMapping>>,
    TError,
    { comparisonId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAssessmentsAccumulationMapping>>,
  TError,
  { comparisonId: string },
  TContext
> => {
  const mutationKey = ['createAssessmentsAccumulationMapping'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAssessmentsAccumulationMapping>>,
    { comparisonId: string }
  > = (props) => {
    const { comparisonId } = props ?? {};

    return createAssessmentsAccumulationMapping(comparisonId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAssessmentsAccumulationMappingMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAssessmentsAccumulationMapping>>
>;

export type CreateAssessmentsAccumulationMappingMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 積算マッピング作成
 */
export const useCreateAssessmentsAccumulationMapping = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAssessmentsAccumulationMapping>>,
      TError,
      { comparisonId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAssessmentsAccumulationMapping>>,
  TError,
  { comparisonId: string },
  TContext
> => {
  const mutationOptions = getCreateAssessmentsAccumulationMappingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 指定された査定積算に紐づくマッピング一覧を取得します
 * @summary 積算マッピング取得
 */
export const getAssessmentsAccumulationMappings = (
  assessmentsAccumulationId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AssessmentsAccumulationMappingsResponse>(
    {
      url: `/assessments/accumulations/${assessmentsAccumulationId}/mappings`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetAssessmentsAccumulationMappingsQueryKey = (
  assessmentsAccumulationId?: string,
) => {
  return [`/assessments/accumulations/${assessmentsAccumulationId}/mappings`] as const;
};

export const getGetAssessmentsAccumulationMappingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssessmentsAccumulationMappings>>,
  TError = ErrorType<ErrorResponse>,
>(
  assessmentsAccumulationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsAccumulationMappings>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAssessmentsAccumulationMappingsQueryKey(assessmentsAccumulationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssessmentsAccumulationMappings>>> = ({
    signal,
  }) => getAssessmentsAccumulationMappings(assessmentsAccumulationId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assessmentsAccumulationId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssessmentsAccumulationMappings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAssessmentsAccumulationMappingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssessmentsAccumulationMappings>>
>;
export type GetAssessmentsAccumulationMappingsQueryError = ErrorType<ErrorResponse>;

export function useGetAssessmentsAccumulationMappings<
  TData = Awaited<ReturnType<typeof getAssessmentsAccumulationMappings>>,
  TError = ErrorType<ErrorResponse>,
>(
  assessmentsAccumulationId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsAccumulationMappings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssessmentsAccumulationMappings>>,
          TError,
          Awaited<ReturnType<typeof getAssessmentsAccumulationMappings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAssessmentsAccumulationMappings<
  TData = Awaited<ReturnType<typeof getAssessmentsAccumulationMappings>>,
  TError = ErrorType<ErrorResponse>,
>(
  assessmentsAccumulationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsAccumulationMappings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssessmentsAccumulationMappings>>,
          TError,
          Awaited<ReturnType<typeof getAssessmentsAccumulationMappings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAssessmentsAccumulationMappings<
  TData = Awaited<ReturnType<typeof getAssessmentsAccumulationMappings>>,
  TError = ErrorType<ErrorResponse>,
>(
  assessmentsAccumulationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsAccumulationMappings>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 積算マッピング取得
 */

export function useGetAssessmentsAccumulationMappings<
  TData = Awaited<ReturnType<typeof getAssessmentsAccumulationMappings>>,
  TError = ErrorType<ErrorResponse>,
>(
  assessmentsAccumulationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsAccumulationMappings>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAssessmentsAccumulationMappingsQueryOptions(
    assessmentsAccumulationId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 指定された査定積算のマッピングを更新します
 * @summary 積算マッピング更新
 */
export const patchAssessmentsAccumulationMapping = (
  assessmentsAccumulationId: string,
  assessmentsAccumulationPatchRequest: BodyType<AssessmentsAccumulationPatchRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/assessments/accumulations/${assessmentsAccumulationId}/mappings`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: assessmentsAccumulationPatchRequest,
    },
    options,
  );
};

export const getPatchAssessmentsAccumulationMappingMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchAssessmentsAccumulationMapping>>,
    TError,
    { assessmentsAccumulationId: string; data: BodyType<AssessmentsAccumulationPatchRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchAssessmentsAccumulationMapping>>,
  TError,
  { assessmentsAccumulationId: string; data: BodyType<AssessmentsAccumulationPatchRequest> },
  TContext
> => {
  const mutationKey = ['patchAssessmentsAccumulationMapping'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchAssessmentsAccumulationMapping>>,
    { assessmentsAccumulationId: string; data: BodyType<AssessmentsAccumulationPatchRequest> }
  > = (props) => {
    const { assessmentsAccumulationId, data } = props ?? {};

    return patchAssessmentsAccumulationMapping(assessmentsAccumulationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchAssessmentsAccumulationMappingMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchAssessmentsAccumulationMapping>>
>;
export type PatchAssessmentsAccumulationMappingMutationBody =
  BodyType<AssessmentsAccumulationPatchRequest>;
export type PatchAssessmentsAccumulationMappingMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 積算マッピング更新
 */
export const usePatchAssessmentsAccumulationMapping = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchAssessmentsAccumulationMapping>>,
      TError,
      { assessmentsAccumulationId: string; data: BodyType<AssessmentsAccumulationPatchRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchAssessmentsAccumulationMapping>>,
  TError,
  { assessmentsAccumulationId: string; data: BodyType<AssessmentsAccumulationPatchRequest> },
  TContext
> => {
  const mutationOptions = getPatchAssessmentsAccumulationMappingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 査定オプション取得API

fieldsパラメータで指定された項目のマスタデータを返す。
例: fields=accumulation_tag で査定タグ(accumulation_tag)のマスタデータを取得

 * @summary 査定オプション取得
 */
export const getAssessmentsOptions = (
  params: GetAssessmentsOptionsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AssessmentsOptionsResponse>(
    { url: `/assessments/options`, method: 'GET', params, signal },
    options,
  );
};

export const getGetAssessmentsOptionsQueryKey = (params?: GetAssessmentsOptionsParams) => {
  return [`/assessments/options`, ...(params ? [params] : [])] as const;
};

export const getGetAssessmentsOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssessmentsOptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetAssessmentsOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsOptions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAssessmentsOptionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssessmentsOptions>>> = ({ signal }) =>
    getAssessmentsOptions(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssessmentsOptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAssessmentsOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssessmentsOptions>>
>;
export type GetAssessmentsOptionsQueryError = ErrorType<ErrorResponse>;

export function useGetAssessmentsOptions<
  TData = Awaited<ReturnType<typeof getAssessmentsOptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetAssessmentsOptionsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsOptions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssessmentsOptions>>,
          TError,
          Awaited<ReturnType<typeof getAssessmentsOptions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAssessmentsOptions<
  TData = Awaited<ReturnType<typeof getAssessmentsOptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetAssessmentsOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsOptions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssessmentsOptions>>,
          TError,
          Awaited<ReturnType<typeof getAssessmentsOptions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAssessmentsOptions<
  TData = Awaited<ReturnType<typeof getAssessmentsOptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetAssessmentsOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsOptions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 査定オプション取得
 */

export function useGetAssessmentsOptions<
  TData = Awaited<ReturnType<typeof getAssessmentsOptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetAssessmentsOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsOptions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAssessmentsOptionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 査定タグを新規作成する。
 * @summary 査定タグ作成
 */
export const createAccumulationTag = (
  accumulationTagCreateRequest: BodyType<AccumulationTagCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<IdResponse>(
    {
      url: `/assessments/accumulation-tags`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: accumulationTagCreateRequest,
      signal,
    },
    options,
  );
};

export const getCreateAccumulationTagMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAccumulationTag>>,
    TError,
    { data: BodyType<AccumulationTagCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAccumulationTag>>,
  TError,
  { data: BodyType<AccumulationTagCreateRequest> },
  TContext
> => {
  const mutationKey = ['createAccumulationTag'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAccumulationTag>>,
    { data: BodyType<AccumulationTagCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createAccumulationTag(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAccumulationTagMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAccumulationTag>>
>;
export type CreateAccumulationTagMutationBody = BodyType<AccumulationTagCreateRequest>;
export type CreateAccumulationTagMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 査定タグ作成
 */
export const useCreateAccumulationTag = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAccumulationTag>>,
      TError,
      { data: BodyType<AccumulationTagCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAccumulationTag>>,
  TError,
  { data: BodyType<AccumulationTagCreateRequest> },
  TContext
> => {
  const mutationOptions = getCreateAccumulationTagMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 査定タグを更新する。
 * @summary 査定タグ更新
 */
export const updateAccumulationTag = (
  accumulationTagId: string,
  accumulationTagUpdateRequest: BodyType<AccumulationTagUpdateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/assessments/accumulation-tags/${accumulationTagId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: accumulationTagUpdateRequest,
    },
    options,
  );
};

export const getUpdateAccumulationTagMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAccumulationTag>>,
    TError,
    { accumulationTagId: string; data: BodyType<AccumulationTagUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAccumulationTag>>,
  TError,
  { accumulationTagId: string; data: BodyType<AccumulationTagUpdateRequest> },
  TContext
> => {
  const mutationKey = ['updateAccumulationTag'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAccumulationTag>>,
    { accumulationTagId: string; data: BodyType<AccumulationTagUpdateRequest> }
  > = (props) => {
    const { accumulationTagId, data } = props ?? {};

    return updateAccumulationTag(accumulationTagId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAccumulationTagMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAccumulationTag>>
>;
export type UpdateAccumulationTagMutationBody = BodyType<AccumulationTagUpdateRequest>;
export type UpdateAccumulationTagMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 査定タグ更新
 */
export const useUpdateAccumulationTag = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAccumulationTag>>,
      TError,
      { accumulationTagId: string; data: BodyType<AccumulationTagUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateAccumulationTag>>,
  TError,
  { accumulationTagId: string; data: BodyType<AccumulationTagUpdateRequest> },
  TContext
> => {
  const mutationOptions = getUpdateAccumulationTagMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 査定タグを削除する。

削除時に紐付けられた査定積算との関連も解除される。

 * @summary 査定タグ削除
 */
export const deleteAccumulationTag = (
  accumulationTagId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    { url: `/assessments/accumulation-tags/${accumulationTagId}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteAccumulationTagMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccumulationTag>>,
    TError,
    { accumulationTagId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAccumulationTag>>,
  TError,
  { accumulationTagId: string },
  TContext
> => {
  const mutationKey = ['deleteAccumulationTag'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAccumulationTag>>,
    { accumulationTagId: string }
  > = (props) => {
    const { accumulationTagId } = props ?? {};

    return deleteAccumulationTag(accumulationTagId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAccumulationTagMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAccumulationTag>>
>;

export type DeleteAccumulationTagMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 査定タグ削除
 */
export const useDeleteAccumulationTag = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAccumulationTag>>,
      TError,
      { accumulationTagId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAccumulationTag>>,
  TError,
  { accumulationTagId: string },
  TContext
> => {
  const mutationOptions = getDeleteAccumulationTagMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 査定積算にタグを紐付ける。
既に紐付いている場合は何もせず成功を返す（冪等）。

 * @summary 査定積算タグ紐付け追加
 */
export const createAccumulationTagAccumulation = (
  assessmentsAccumulationId: string,
  accumulationTagId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/assessments/accumulations/${assessmentsAccumulationId}/tags/${accumulationTagId}`,
      method: 'POST',
      signal,
    },
    options,
  );
};

export const getCreateAccumulationTagAccumulationMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAccumulationTagAccumulation>>,
    TError,
    { assessmentsAccumulationId: string; accumulationTagId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAccumulationTagAccumulation>>,
  TError,
  { assessmentsAccumulationId: string; accumulationTagId: string },
  TContext
> => {
  const mutationKey = ['createAccumulationTagAccumulation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAccumulationTagAccumulation>>,
    { assessmentsAccumulationId: string; accumulationTagId: string }
  > = (props) => {
    const { assessmentsAccumulationId, accumulationTagId } = props ?? {};

    return createAccumulationTagAccumulation(
      assessmentsAccumulationId,
      accumulationTagId,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAccumulationTagAccumulationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAccumulationTagAccumulation>>
>;

export type CreateAccumulationTagAccumulationMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 査定積算タグ紐付け追加
 */
export const useCreateAccumulationTagAccumulation = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAccumulationTagAccumulation>>,
      TError,
      { assessmentsAccumulationId: string; accumulationTagId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAccumulationTagAccumulation>>,
  TError,
  { assessmentsAccumulationId: string; accumulationTagId: string },
  TContext
> => {
  const mutationOptions = getCreateAccumulationTagAccumulationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 査定積算からタグの紐付けを削除する。
既に紐付いていない場合は何もせず成功を返す（冪等）。

 * @summary 査定積算タグ紐付け削除
 */
export const deleteAccumulationTagAccumulation = (
  assessmentsAccumulationId: string,
  accumulationTagId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/assessments/accumulations/${assessmentsAccumulationId}/tags/${accumulationTagId}`,
      method: 'DELETE',
    },
    options,
  );
};

export const getDeleteAccumulationTagAccumulationMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccumulationTagAccumulation>>,
    TError,
    { assessmentsAccumulationId: string; accumulationTagId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAccumulationTagAccumulation>>,
  TError,
  { assessmentsAccumulationId: string; accumulationTagId: string },
  TContext
> => {
  const mutationKey = ['deleteAccumulationTagAccumulation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAccumulationTagAccumulation>>,
    { assessmentsAccumulationId: string; accumulationTagId: string }
  > = (props) => {
    const { assessmentsAccumulationId, accumulationTagId } = props ?? {};

    return deleteAccumulationTagAccumulation(
      assessmentsAccumulationId,
      accumulationTagId,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAccumulationTagAccumulationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAccumulationTagAccumulation>>
>;

export type DeleteAccumulationTagAccumulationMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 査定積算タグ紐付け削除
 */
export const useDeleteAccumulationTagAccumulation = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAccumulationTagAccumulation>>,
      TError,
      { assessmentsAccumulationId: string; accumulationTagId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAccumulationTagAccumulation>>,
  TError,
  { assessmentsAccumulationId: string; accumulationTagId: string },
  TContext
> => {
  const mutationOptions = getDeleteAccumulationTagAccumulationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
